import { createContext } from 'react'
// Direct import to avoid circular dependency
import createStateContext from './utils/createStateContext'

// Contains current locale
export const localeContext = createContext(null)

// Contains app copy
export const appCopyContext = createContext(null)

// Contains hub app copy
export const hubAppCopyContext = createContext(null)

// Contains flash message
export const flashMessageContext = createContext(null)

// Contains current logged-in user
export const currentUserContext = createStateContext(null)

// Contains the expanded nav items in SideNavigation
export const expandedNavItemsContext = createContext(null)

// Maintains whether the side nav is expanded in a hub
export const expandedSideNavContext = createContext(null)